<template>
  <div class="b-editable-content-textarea">
    <template v-if="editing">
      <BTextarea
        v-bind="textareaProps"
        ref="textarea"
        v-model="internalValue"
        class="textarea"
        @blur="handleCheck"
      />
    </template>
    <template v-else>
      <div
        class="content"
        :class="{editing, editable}"
        @click="handleEdit"
      >
        {{ formattedValue }}
      </div>
    </template>
  </div>
</template>

<script>
import { altText } from '@/utils/alt';

export default {
  props: {
    placeholder: String,
    modelValue: {
      type: String,
      default: null,
    },
    required: Boolean,
    editable: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    'update:modelValue',
    'click',
    'cancel',
  ],
  data () {
    return {
      internalValue: '',
      originalValue: '',
      editing: false,
    };
  },
  computed: {
    textareaProps () {
      return {
        placeholder: this.placeholder,
        rows: 2,
        autosize: true,
      };
    },
    rules () {
      return {
        content: [
          { required: true, message: 'Please input Activity name', trigger: 'blur' },
        ],
      };
    },
    formattedValue () {
      return altText(this.internalValue);
    },
  },
  watch: {
    modelValue: {
      handler (val) {
        this.internalValue = val;
        this.originalValue = val;
      },
      immediate: true,
    },
  },
  methods: {
    handleEdit (e) {
      if (!this.editable) return;
      this.editing = true;
      this.$emit('click', e);
      this.setFocus();
    },
    handleCheck (e) {
      if (!this.editable) return;
      if (this.internalValue === this.originalValue) {
        this.$emit('cancel', e);
        this.editing = false;
        return false;
      } else {
        this.$emit('update:modelValue', this.internalValue);
        this.originalValue = this.internalValue;
        this.editing = false;
      }
    },
    setFocus () {
      if (!this.editable) return;
      this.$nextTick(() => this.$refs?.textarea?.setFocus());
    },
  },
};
</script>

<style lang="scss" scoped>
  .content {
    width: 100%;
    border: 1px solid transparent;
    border-radius: 4px;
    transition: all 300ms $standard-easing;
    padding: $basespace-50 $basespace-100;
    white-space: pre-wrap;
    word-wrap: break-word;

    &.editable:not(.editing) {
      &:hover {
        border: 1px solid $bdcolor-base;
        cursor: pointer;
      }
    }
  }
</style>
